import { enUS, enGB, enAU, es, fr, frCA, ar } from 'date-fns/locale';
var supportedLocales = {
  'en-US': enUS,
  en_US: enUS,
  'en-GB': enGB,
  en_GB: enGB,
  'en-AU': enAU,
  en_AU: enAU,
  es: es,
  fr: fr,
  'fr-CA': frCA,
  fr_CA: frCA,
  ar: ar
};
export default supportedLocales;